var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-video nacelle"},[_c('video',{ref:"product-video",attrs:{"src":_vm.source,"controls":_vm.showControls,"loop":_vm.loop,"autoplay":_vm.autoplay},domProps:{"muted":_vm.muted}})])
}
var staticRenderFns = []

export { render, staticRenderFns }